import { baseURL, get, post, getActConfig } from './request';
export function getPageInit() { }
/**
 * 获取活动信息
 */
export function getActInfo(actKey) {
    var actId = getActConfig().actId || actKey;
    return get({
        url: "".concat(baseURL, "/page/act-info/").concat(actId),
        ignoreBaseURL: true,
        data: {
            actId: actId,
        },
    });
}
/**
 * 获取活动配置
 */
export function getConfig(actKey) {
    var actId = getActConfig().actId || actKey;
    return get({
        url: "".concat(baseURL, "/page/config/").concat(actId),
        ignoreBaseURL: true,
        data: {
            actId: actId,
        },
    });
}
/**
 * 获取榜单数据
 */
export function getRankList(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/rank/list/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取榜单奖励配置
 * @param params
 * @returns
 */
export function getRankReward(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/rank/reward/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取任务列表
 */
export function getTaskList(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/task/list/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 领取任务奖励
 */
export function getTaskReward(params) {
    var actId = getActConfig().actId || params.actId;
    return post({
        url: "".concat(baseURL, "/task/get-reward/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取奖池预览
 */
export function getRewardPreview(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/reward/preview/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取抽奖数据
 */
export function getLotteryRecord(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/reward/record/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 统一的抽奖接口
 * @param num 抽奖次数，默认抽1次
 * @param params 抽奖参数
 * @returns
 */
export function requestLottery(params) {
    var actId = getActConfig().actId || params.actId;
    return post({
        url: "".concat(baseURL, "/reward/draw/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取兑换列表
 * @param params 兑换参数
 * @returns
 */
export function getExchangeList(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/reward/exchange-list/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 兑换礼物
 */
export function requestExchange(params) {
    var actId = getActConfig().actId || params.actId;
    return post({
        url: "".concat(baseURL, "/reward/exchange/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取规则文本内容
 */
export function getRuleText(params) {
    var actId = getActConfig().actId || params.actId;
    var action = params.isPreview ? 'preview-detail' : "detail/".concat(actId);
    return get({
        url: "".concat(baseURL, "/rule/").concat(action),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 获取图鉴列表
 */
export function getCollectionList(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/collection/detail/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
export function getActTickets(params) {
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/page/tickets/").concat(actId),
        ignoreBaseURL: true,
        data: params,
    });
}
/**
 * 领取图鉴奖励
 */
export function receiveCollectionReward(params) {
    var bookId = params.bookId, itemKey = params.itemKey;
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/collection/receive/").concat(actId),
        ignoreBaseURL: true,
        data: {
            bookId: bookId,
            itemKey: itemKey,
        },
    });
}
/**
 * 领取等级奖励
 * @param params
 * @returns
 */
export function receiveLevelReward(params) {
    var levelId = params.levelId, memberId = params.memberId, target = params.target;
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/level/receive/").concat(actId),
        ignoreBaseURL: true,
        data: {
            levelId: levelId,
            memberId: memberId,
            target: target,
        },
    });
}
/**
 * 领取所有等级奖励
 * @param params
 * @returns
 */
export function receiveAllLevelReward(params) {
    var levelId = params.levelId, memberId = params.memberId;
    var actId = getActConfig().actId || params.actId;
    return get({
        url: "".concat(baseURL, "/level/receive-all/").concat(actId),
        ignoreBaseURL: true,
        data: {
            levelId: levelId,
            memberId: memberId,
        },
    });
}
